import {useSigma} from "@react-sigma/core";
import {useEffect} from "react";

import {AppSettings} from "../../settings";
import {useTheCellMapContext} from "../../contexts/TheCellMapContext";

const GraphSelectionController = () => {
  const {selectedGenes} = useTheCellMapContext();

  const sigma = useSigma();
  const graph = sigma.getGraph();

  /**
   * Highlight selected nodes on the network
   */
  useEffect(() => {
    if (!graph) return;

    const selectedNodes: number[] = [];

    selectedGenes.forEach((selected) => {
      if (!!selected.node && graph.hasNode(selected.node.i)) { // Check if the selected gene is a node
        graph.setNodeAttribute(selected.node.i, 'color', AppSettings.NODE_SELECTED_COLOUR);
        graph.setNodeAttribute(selected.node.i, 'size', AppSettings.NODE_SELECTED_SIZE);
        graph.setNodeAttribute(selected.node.i, "forceLabel", true);
        selectedNodes.push(selected.node.i);
      }
    });


    return () => {
      selectedNodes.forEach((node) => {
        if (graph.hasNode(node)) { // Avoid errors if the node is no longer in the graph for some reason
          graph.setNodeAttribute(node, 'color', AppSettings.NODE_COLOUR);
          graph.setNodeAttribute(node, 'size', AppSettings.NODE_SIZE);
          graph.setNodeAttribute(node, "forceLabel", false);
        }
      })
    };
  }, [selectedGenes, graph]);

  return null;
};

export default GraphSelectionController;
